import { FileRejectionState } from './getFilesToUpload';
import TonalIconButton from '@/components/TonalIconButton';
import { Tooltip } from '@mui/material';
import { Refresh as RetryIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import FormattedHtmlMessage from '@/components/FormattedHtmlMessage';

type FileRejectionErrorMessageProps = {
  fileRejectionState:
    | FileRejectionState.ONE_FILE_AND_REJECTED
    | FileRejectionState.MULTIPLE_FILES_ALL_REJECTED;
  onDismiss: () => void;
};

const FileRejectionErrorMessage = ({
  fileRejectionState,
  onDismiss,
}: FileRejectionErrorMessageProps) => (
  <>
    <span>
      <FormattedHtmlMessage
        id={`portfolio.challenge.files.add.upload_image.errors.file_too_large.label.${fileRejectionState === FileRejectionState.ONE_FILE_AND_REJECTED ? 'singular' : 'plural'}`}
      />
    </span>
    <Tooltip
      title={
        <FormattedMessage
          id={`portfolio.challenge.files.add.upload_image.errors.file_too_large.upload_different_file_tooltip.${
            fileRejectionState === FileRejectionState.ONE_FILE_AND_REJECTED
              ? 'singular'
              : 'plural'
          }`}
        />
      }
    >
      <TonalIconButton size="small" onClick={onDismiss}>
        <RetryIcon fontSize="small" />
      </TonalIconButton>
    </Tooltip>
  </>
);

export default FileRejectionErrorMessage;
